import { get, handleError } from '@/lib/http-adapter';
import { Tenant } from '@/state/tenant';

export const getTenant = async () => {
  try {
    const response = await get<{
      tenant: Tenant;
    }>(`/public/tenants`);

    return response?.tenant;
  } catch (error) {
    handleError(error);
  }
};
